module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('group', {
    attrs: {
      "gutter": "8"
    }
  }, [_c('cell', {
    attrs: {
      "title": "《人行征信查询授权（众安）》"
    },
    on: {
      "click": function($event) {
        return _vm.nextRoute('contract')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/link.png"),
      "height": "12",
      "width": "7",
      "alt": ""
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-993ddeae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contractlist.vue
// module id = 213
// module chunks = 0